module.exports = __webpack_public_path__ + "static/media/food_image.855b79c1.jpg";